// components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer id="contact" style={{ backgroundColor: "#080808", color: "#a0aec0", padding: "60px 0 20px" }}>
            <div className="container">
                <div className="row">
                    {/* Added text-center text-md-start for responsive alignment */}
                    <div className="col-md-4 mb-4 text-center text-md-start">
                        <h4 style={{ color: "#c5a059", fontFamily: "'Cormorant Garamond', serif", letterSpacing: "2px", textTransform: "uppercase" }}>
                            Bundle Madness
                        </h4>
                        <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "0.9rem", lineHeight: "1.8" }}>
                            Premium hair bundles and extensions for every style. Luxury you can feel.
                        </p>
                    </div>

                    {/* Added text-center text-md-start for responsive alignment */}
                    <div className="col-md-4 mb-4 text-center text-md-start">
                        <h4 style={{ color: "#c5a059", fontFamily: "'Cormorant Garamond', serif", letterSpacing: "2px", textTransform: "uppercase" }}>
                            Support
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0, fontFamily: "'Montserrat', sans-serif", fontSize: "0.9rem", lineHeight: "2" }}>
                            <li>
                                <Link to="/customer-care" style={{ color: "#a0aec0", textDecoration: "none", transition: "color 0.3s ease" }} onMouseOver={(e) => e.target.style.color = "#d4af37"} onMouseOut={(e) => e.target.style.color = "#a0aec0"}>
                                    Contact & Returns
                                </Link>
                            </li>
                            <li>
                                <Link to="/care-guide" style={{ color: "#a0aec0", textDecoration: "none", transition: "color 0.3s ease" }} onMouseOver={(e) => e.target.style.color = "#d4af37"} onMouseOut={(e) => e.target.style.color = "#a0aec0"}>
                                    Hair Care Guide
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" style={{ color: "#a0aec0", textDecoration: "none", transition: "color 0.3s ease" }} onMouseOver={(e) => e.target.style.color = "#d4af37"} onMouseOut={(e) => e.target.style.color = "#a0aec0"}>
                                    Terms And Conditions
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Added text-center text-md-start for responsive alignment */}
                    <div className="col-md-4 mb-4 text-center text-md-start">
                        <h4 style={{ color: "#c5a059", fontFamily: "'Cormorant Garamond', serif", letterSpacing: "2px", textTransform: "uppercase" }}>
                            Follow Us
                        </h4>
                        {/* Added justify-content classes so icons center on mobile, left-align on desktop */}
                        <div className="social-icons d-flex justify-content-center justify-content-md-start gap-3" style={{ fontSize: "1.2rem" }}>
                            <a href="https://www.instagram.com/bundlemadness.hair?igsh=bGJpd2dzY2txOWV1" style={{ color: "#a0aec0", transition: "color 0.3s ease" }} onMouseOver={(e) => e.target.style.color = "#d4af37"} onMouseOut={(e) => e.target.style.color = "#a0aec0"}>
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61570161646182" style={{ color: "#a0aec0", transition: "color 0.3s ease" }} onMouseOver={(e) => e.target.style.color = "#d4af37"} onMouseOut={(e) => e.target.style.color = "#a0aec0"}>
                                <i className="fab fa-facebook"></i>
                            </a>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href="https://www.tiktok.com/@bundle.madnesshair?_r=1&_t=ZN-96MDKp9VXeg" style={{ color: "#a0aec0", transition: "color 0.3s ease" }} onMouseOver={(e) => e.target.style.color = "#d4af37"} onMouseOut={(e) => e.target.style.color = "#a0aec0"}>
                                <i className="fab fa-tiktok"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row mt-4 pt-4" style={{ borderTop: "1px solid rgba(212, 175, 55, 0.1)" }}>
                    <div className="col text-center">
                        <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "0.8rem", color: "#666", margin: 0 }}>
                            &copy; 2026 Bundle Madness. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;